module.exports = __webpack_public_path__ + "img/banner08.56dae5d3.png";